/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {Margin, Padding} from "../../../config/styles";

export const withSpacing = WrappedComponent => {
    const HOC = ({ padding, margin, className = "", children, ...props }) => {
        if (padding) {
            padding = Object.values(Padding).indexOf(padding) !== -1 ? padding : Padding[padding];

            if (padding) {
                className += " " + padding;
            }
        }

        if (margin) {
            margin = Object.values(Margin).indexOf(margin) !== -1 ? margin : Margin[margin];

            if (margin) {
                className += " " + margin;
            }
        }

        return (<WrappedComponent className={className} {...props}>{children}</WrappedComponent>);
    };

    HOC.displayName = `withSpacing(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

    return HOC;
};


withSpacing.propTypes = {
    padding: PropTypes.oneOf([].concat(Object.keys(Padding), Object.values(Padding))),
    margin: PropTypes.oneOf([].concat(Object.keys(Margin), Object.values(Margin)))
};
